import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import SingleChoice from './types/SingleChoice';
import Points from './types/Points';
import Value from './types/Value';
import MultiChoice from './types/MultiChoice';
import PointsWithLimitUniquenessConstraint from './types/PointsWithLimitUniquenessConstraint';

class Answers extends React.Component {
  state = {
    district: this.props.district || null,
  };

  handleDistrictChange = district => this.setState({ district });
  
  renderEmptyDetailsMessage = () => (<p>Nie zdefiniowano formularza do głosowania</p>);

  renderDistrictPicker = () => (
    <div className="row" style={{ justifyContent: 'center' }}>
      {this.props.votingSettings.districts.map(district => (
        <a key={district} href="#" onClick={() => this.handleDistrictChange(district)} className="col-sm-6 col-md-4 obszar-link">
          <div className="inner-wrapper">
            <h2>{district}</h2>
            <p>Głosuj na realizacje zadań na obszarze</p>
            <span href="#" className="btn">Głosuj</span>
          </div>
        </a>)
      )}
    </div>
  )

  renderDetails = (votingSettings, district, exludedDistrict, limitAnswers) => {
    const applications = votingSettings.projects.filter(a => district ? a.district === district : true).filter(a => exludedDistrict ? a.district !== exludedDistrict : true);
    const groupByDistricts = votingSettings.districts && votingSettings.districts.length && !votingSettings.districtCityFiltersEnabled ? true : false;
    switch (votingSettings.type) {
      case 'points':
        return votingSettings.pointsLimitUniquenessConstraint
          ? <PointsWithLimitUniquenessConstraint field="votes" max={votingSettings.pointsLimit} applications={applications} groupByDistricts={groupByDistricts} districts={votingSettings.districts} />
          : <Points field="votes" max={votingSettings.pointsLimit} applications={applications} groupByDistricts={groupByDistricts} districts={votingSettings.districts} />;
      case 'value':
        return <Value field="applicationIds" max={district ? votingSettings.districtsAmountsLimits.find(v => v.district === district).amountLimit : votingSettings.amountLimit} applications={applications} groupByDistricts={groupByDistricts} districts={votingSettings.districts} />;
      case 'singleChoice':
        return <SingleChoice field="applicationId" applications={applications} groupByDistricts={groupByDistricts} districts={votingSettings.districts} />;
      case 'multiChoice':
        return <MultiChoice field="applicationIds" applications={applications} categoriesChoiceLimits={votingSettings.categoriesChoiceLimits} groupByDistricts={groupByDistricts} districts={votingSettings.districts} limitAnswers={limitAnswers} />;
      default:
        return this.renderEmptyDetailsMessage();
    }
  }

  render() {
    const { votingSettings, error, exludedDistrict, limitAnswers } = this.props;
    const { district } = this.state;
    return (
      <React.Fragment>
        {votingSettings.districts && votingSettings.districts.length && votingSettings.districtCityFiltersEnabled && !district
          ? <div className="box">
              <div className="col-sm-12">
                {this.renderDistrictPicker()}
              </div>
            </div>
          : <React.Fragment>
              {district && <div className="box">
                <div className="col-sm-12">
                  <h2 style={{ marginBottom: 0 }}>Projekty z obszaru {district}</h2>
                </div>
              </div>}
              {this.renderDetails(votingSettings, district, exludedDistrict, limitAnswers)}
            </React.Fragment>
        }
        {error &&
          <div className="box">
            <div className="col-sm-12">
              <Typography variant="caption" gutterBottom color="error">{error}</Typography>
            </div>
          </div>}
      </React.Fragment>
    );
  }
}

Answers.propTypes = {
  votingSettings: PropTypes.object.isRequired,
  error: PropTypes.string,
  district: PropTypes.string,
  exludedDistrict: PropTypes.string,
  limitAnswers: PropTypes.number,
};

export default Answers;


// WEBPACK FOOTER //
// ./src/components/budget/Answers.js